// extracted by mini-css-extract-plugin
export default {"section":"Section_section__WJ4bY","cogwheel":"Section_cogwheel__ouZrk","atom":"Section_atom__jCEr6"};